import React from 'react';
export const ScrollingTagline = () => {
  const phrases = ['Future-ready teams', 'AI-powered professionals', 'Smarter educators', 'High-performing teams', 'Stronger communities', 'Better communicators', 'Next-generation leaders', 'Connected professionals', 'Modern organizations'];
  // Duplicate phrases to create a seamless loop
  const duplicatedPhrases = [...phrases, ...phrases];
  return <div className="bg-gold text-navy py-4 overflow-hidden relative flex items-center border-y-2 border-navy/10" data-id="element-1036" data-mp="2tqt2dm1olgvk">
      <style data-id="element-1037" data-mp="2oqx7qdevj1so">
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-marquee {
            display: flex;
            white-space: nowrap;
            animation: marquee 30s linear infinite;
          }
          .animate-marquee:hover {
            animation-play-state: paused;
          }
        `}
      </style>
      <div className="animate-marquee" data-id="element-1038" data-mp="dzotlp2wv8z8">
        {duplicatedPhrases.map((phrase, index) => <div key={index} className="flex items-center" data-id="element-1039" data-mp="6dvgphsud01" data-mpi={index}>
            <span className="text-xl md:text-2xl font-bold uppercase tracking-wider mx-6 whitespace-nowrap" data-id="element-1040" data-mp="5608oyxmnt8u">
              {phrase}
            </span>
            <span className="w-2 h-2 rounded-full bg-navy/50 mx-2" data-id="element-1041" data-mp="3ndfxp2cwwpoy"></span>
          </div>)}
      </div>
    </div>;
};